export default __webpack_public_path__ + "static/media/speaker.458d40c0.jpg";